import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.2",
  "description": "Turborepo 1.2 introduces improved task filtering, artifact signing and integrity, human-readable and JSON dry runs, and more!",
  "date": "2022/04/08",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Since releasing Turborepo v1.1 in late January, we've seen incredible adoption and community growth:"
  }, {
    "heading": "",
    "content": "6.5k+ GitHub Stars"
  }, {
    "heading": "",
    "content": "140k+ weekly npm downloads (doubling since our last blog post for v1.1)"
  }, {
    "heading": "",
    "content": "95+ OSS contributors"
  }, {
    "heading": "",
    "content": "900+ members of the Turborepo Community Discord"
  }, {
    "heading": "",
    "content": "1.6 years of Time Saved through Remote Caching on Vercel, saving more than 2.5 months every week"
  }, {
    "heading": "",
    "content": "We've further improved ergonomics, observability, and security with Turborepo v1.2 featuring:"
  }, {
    "heading": "",
    "content": "New Task Filtering API: --filter adds more powerful task filtering capabilities to turbo run"
  }, {
    "heading": "",
    "content": "Human-readable and JSON dry runs: --dry-run flag can print out information about a turbo run without executing any tasks, in both human and JSON-parse friendly formats"
  }, {
    "heading": "",
    "content": "Improved Internal Scheduler and Graph: We refactored turbo 's internal scheduler and graph to be more ergonomic and predictable"
  }, {
    "heading": "",
    "content": "Enhanced Remote Cache Security: Cryptographically sign remote cache artifacts with your own secret key"
  }, {
    "heading": "",
    "content": "Update today by running npm install turbo@latest. After running turbo run for the first time, you'll see instructions about how to use @turbo/codemod to run automatic migrations for v1.2."
  }, {
    "heading": "new-task-filtering-api",
    "content": "We are excited to release one of our most requested features: the ability to expressively filter tasks through a --filter flag. The --filter flag is the much more powerful successor to the current combination of --scope, --include-dependencies, --since, and --no-deps flags."
  }, {
    "heading": "new-task-filtering-api",
    "content": "With --filter you can tell turbo to restrict executing commands to a subset of matched packages in your monorepo based on name, folder, or even if it has changed since a git commit ref."
  }, {
    "heading": "new-task-filtering-api",
    "content": "Take a look at some examples of what you can accomplish with the new --filter command:"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=<package_name> - match by exact package name or glob pattern"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=...<package_name>- match by package name/glob and include all dependent packages of matches"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=...^<package_name>- match by package name/glob and include all dependent packages of matches, but exclude the matches themselves"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=<package_name>... - match by package name/glob and include all the matched packages' dependencies"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=<package_name>^... - match by package name/glob and include all matched package dependencies, but exclude the matches themselves"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter={./path/to/package} - match by path or filesystem glob pattern"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=[origin/main] - match by changed packages since a git commit ref"
  }, {
    "heading": "new-task-filtering-api",
    "content": "You can use multiple filters together to get even more granular filtering as well as combine each part of the above patterns {}, [] , ^ , and ... to express more complex behavior."
  }, {
    "heading": "new-task-filtering-api",
    "content": "For example, if you had an app located in ./apps/web directory with local packages used as dependencies, and a Turborepo pipeline where test depends on ^build topologically, running:"
  }, {
    "heading": "new-task-filtering-api",
    "content": "would tell turbo to ensure dependencies are built and to run the test script in all of the local dependencies of the app located in ./apps/web, not including that app itself, if the app has changed since HEAD^1."
  }, {
    "heading": "new-task-filtering-api",
    "content": "For more details and examples, refer to the new filtering documentation."
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "You can now see the impact of turbo run without actually executing any commands by appending either --dry-run or --dry-run=json to any turbo run command. This will result in either human or JSON output."
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "Dry runs are incredibly useful for two situations:"
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "Debugging and testing run options"
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "Using turbo filtering and task graphs for building automations"
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "We hope that this will improve visibility into what turbo is doing, speeding up debugging, and make it easier to leverage turbo in dynamic CI/CD systems."
  }, {
    "heading": "improved-internal-scheduler-and-graph",
    "content": "When using turbo run, every package.json task is added to an internal graph to map dependencies based on the inferred relationships defined in your Turborepo pipeline. This task graph allows Turborepo to efficiently schedule incremental concurrent task running and cache task outputs for later use."
  }, {
    "heading": "improved-internal-scheduler-and-graph",
    "content": "We have made major improvements to the internal task scheduler and resulting graph structure, resulting in better performance and a better developer experience. For example, in many cases, you will no longer need to use --include-dependencies. Instead, after specifying your task entry points, the new and improved graph will automatically handle this graph resolution on your behalf."
  }, {
    "heading": "cache-outputs-integrity-and-signature-verification",
    "content": "You can now configure Turborepo to sign remote cache outputs using HMAC-SHA256 with a secret key before uploading them to the Remote Cache. When Turborepo downloads signed cache artifacts, it will now verify the artifact's integrity and authenticity. Any artifact that fails to verify will be ignored, discarded, and treated as a cache miss by Turborepo."
  }, {
    "heading": "cache-outputs-integrity-and-signature-verification",
    "content": "To enable this feature, set the remoteCache options in your turbo.json config file to include signature: true. Then specify your secret key by declaring the TURBO_REMOTE_CACHE_SIGNATURE_KEY environment variable."
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "--sso-team flag now enables teams with SAML tokens to log in through turbo login with correct team permissions"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "--log-output flag allows you to control what logs are printed to the terminal, and when, allowing you to focus only on what's new"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "FORCE_COLOR environment variable is now supported"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "TURBO_FORCE=true environment variable will now force execution"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "--remote-only and TURBO_REMOTE_ONLY=true will tell turbo to only use Remote Caching"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "We now show >>> FULL TURBO when there's at least one task attempted"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "Yarn v2+ with Plug'n'Play (PnP linker) is supported for the turbo run command, but turbo prune is still not fully supported"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "Fixed regression with chrome tracing if --profile is specified"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "You can now set concurrency by percentage of CPUs with --concurrency=50%"
  }, {
    "heading": "were-hiring",
    "content": "The Turborepo team at Vercel is hiring! We're up to five core team members already this year and are looking to hire even more. We're specifically looking for full-time Senior Build Systems Engineers."
  }, {
    "heading": "whats-next",
    "content": "Along with seamless incremental adoption/migration and speeding up CI/CD, we've been focusing on improving Turborepo's day-to-day ergonomics, security, and observability. The new --filter flag, signed artifacts, and dry runs are important steps toward those goals."
  }, {
    "heading": "whats-next",
    "content": "Next up, we'll be focusing an enhanced local development experience, codebase automations, and overall CLI performance."
  }, {
    "heading": "thank-you-contributors",
    "content": "Turborepo is the result of the combined work of over 95 individual developers and our core team."
  }, {
    "heading": "thank-you-contributors",
    "content": "This release was brought to you by the contributions of: @gsoltis09, @jaredpalmer, @gaspar09, @shuding, @rajatkulkarni95, @VanTanev, @Kikobeats, @tknickman, @thebanjomatic, @chelkyl, @elado, @finn-orsini, @becca, @weyert, @ekosz"
  }],
  "headings": [{
    "id": "new-task-filtering-api",
    "content": "New Task Filtering API"
  }, {
    "id": "debug-and-automate-with---dry-run",
    "content": "Debug and Automate with --dry-run"
  }, {
    "id": "improved-internal-scheduler-and-graph",
    "content": "Improved Internal Scheduler and Graph"
  }, {
    "id": "cache-outputs-integrity-and-signature-verification",
    "content": "Cache Outputs Integrity and Signature Verification"
  }, {
    "id": "other-bug-fixes-and-improvements",
    "content": "Other bug fixes and improvements"
  }, {
    "id": "were-hiring",
    "content": "We're hiring!"
  }, {
    "id": "whats-next",
    "content": "What's next?"
  }, {
    "id": "thank-you-contributors",
    "content": "Thank you, contributors"
  }]
};
import __img0 from "./../../public/images/blog/turbo-1-2-0/turbo-dry-run.png";
import {Date} from '#components/blog/date';
import {Authors} from '#components/authors';
export const toc = [{
  depth: 2,
  url: "#new-task-filtering-api",
  title: _jsx(_Fragment, {
    children: "New Task Filtering API"
  })
}, {
  depth: 2,
  url: "#debug-and-automate-with---dry-run",
  title: _jsxs(_Fragment, {
    children: ["Debug and Automate with ", _jsx("code", {
      children: "--dry-run"
    })]
  })
}, {
  depth: 2,
  url: "#improved-internal-scheduler-and-graph",
  title: _jsx(_Fragment, {
    children: "Improved Internal Scheduler and Graph"
  })
}, {
  depth: 2,
  url: "#cache-outputs-integrity-and-signature-verification",
  title: _jsx(_Fragment, {
    children: "Cache Outputs Integrity and Signature Verification"
  })
}, {
  depth: 2,
  url: "#other-bug-fixes-and-improvements",
  title: _jsx(_Fragment, {
    children: "Other bug fixes and improvements"
  })
}, {
  depth: 2,
  url: "#were-hiring",
  title: _jsx(_Fragment, {
    children: "We're hiring!"
  })
}, {
  depth: 2,
  url: "#whats-next",
  title: _jsx(_Fragment, {
    children: "What's next?"
  })
}, {
  depth: 2,
  url: "#thank-you-contributors",
  title: _jsx(_Fragment, {
    children: "Thank you, contributors"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.2"
    }), "\n", "\n", _jsx(Date, {
      children: "Friday, April 8th, 2022"
    }), "\n", _jsx(Authors, {
      authors: ['jaredpalmer', 'becca__z', 'gaspargarcia', 'gregsoltis']
    }), "\n", _jsx(_components.p, {
      children: "Since releasing Turborepo v1.1 in late January, we've seen incredible adoption and community growth:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "6.5k+"
        }), " ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "GitHub Stars"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "140k+"
        }), " weekly npm downloads (doubling since our ", _jsx(_components.a, {
          href: "/blog/turbo-1-1-0",
          children: "last blog post for v1.1"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "95+"
        }), " OSS contributors"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "900+"
        }), " members of the ", _jsx(_components.a, {
          href: "https://turborepo.com/discord",
          children: "Turborepo Community Discord"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "1.6 years"
        }), " of Time Saved through Remote Caching on Vercel, saving more than 2.5 months every week"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "We've further improved ergonomics, observability, and security with Turborepo v1.2 featuring:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#new-task-filtering-api",
          children: _jsx(_components.strong, {
            children: "New Task Filtering API"
          })
        }), ": ", _jsx(_components.code, {
          children: "--filter"
        }), " adds more powerful task filtering capabilities to ", _jsx(_components.code, {
          children: "turbo run"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#debug-and-automate-with---dry-run",
          children: _jsx(_components.strong, {
            children: "Human-readable and JSON dry runs"
          })
        }), ": ", _jsx(_components.code, {
          children: "--dry-run"
        }), " flag can print out information about a ", _jsx(_components.code, {
          children: "turbo run"
        }), " without executing any tasks, in both human and JSON-parse friendly formats"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-internal-scheduler-and-graph",
          children: _jsx(_components.strong, {
            children: "Improved Internal Scheduler and Graph"
          })
        }), ": We refactored ", _jsx(_components.code, {
          children: "turbo"
        }), " 's internal scheduler and graph to be more ergonomic and predictable"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#cache-outputs-integrity-and-signature-verification",
          children: _jsx(_components.strong, {
            children: "Enhanced Remote Cache Security"
          })
        }), ": Cryptographically sign remote cache artifacts with your own secret key"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npm install turbo@latest"
      }), ". After running ", _jsx(_components.code, {
        children: "turbo run"
      }), " for the first time, you'll see instructions about how to use ", _jsx(_components.code, {
        children: "@turbo/codemod"
      }), " to run automatic migrations for ", _jsx(_components.code, {
        children: "v1.2"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "new-task-filtering-api",
      children: "New Task Filtering API"
    }), "\n", _jsxs(_components.p, {
      children: ["We are excited to release one of our most requested features: the ability to expressively filter tasks through a ", _jsx(_components.code, {
        children: "--filter"
      }), " flag. The ", _jsx(_components.code, {
        children: "--filter"
      }), " flag is the much more powerful successor to the current combination of ", _jsx(_components.code, {
        children: "--scope"
      }), ", ", _jsx(_components.code, {
        children: "--include-dependencies"
      }), ", ", _jsx(_components.code, {
        children: "--since"
      }), ", and ", _jsx(_components.code, {
        children: "--no-deps"
      }), " flags."]
    }), "\n", _jsxs(_components.p, {
      children: ["With ", _jsx(_components.code, {
        children: "--filter"
      }), " you can tell ", _jsx(_components.code, {
        children: "turbo"
      }), " to restrict executing commands to a subset of matched packages in your monorepo based on name, folder, or even if it has changed since a git commit ref."]
    }), "\n", _jsxs(_components.p, {
      children: ["Take a look at some examples of what you can accomplish with the new ", _jsx(_components.code, {
        children: "--filter"
      }), " command:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=<package_name>"
        }), " - match by exact package name or glob pattern"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=...<package_name>"
        }), "- match by package name/glob and include all dependent packages of matches"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=...^<package_name>"
        }), "- match by package name/glob and include all dependent packages of matches, but exclude the matches themselves"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=<package_name>..."
        }), " - match by package name/glob and include all the matched packages' dependencies"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=<package_name>^..."
        }), " - match by package name/glob and include all matched package dependencies, but exclude the matches themselves"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter={./path/to/package}"
        }), " - match by path or filesystem glob pattern"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=[origin/main]"
        }), " - match by changed packages since a git commit ref"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["You can use multiple filters together to get even more granular filtering as well as combine each part of the above patterns ", _jsx(_components.code, {
        children: "{}"
      }), ", ", _jsx(_components.code, {
        children: "[]"
      }), " , ", _jsx(_components.code, {
        children: "^"
      }), " , and ", _jsx(_components.code, {
        children: "..."
      }), " to express more complex behavior."]
    }), "\n", _jsxs(_components.p, {
      children: ["For example, if you had an app located in ", _jsx(_components.code, {
        children: "./apps/web"
      }), " directory with local packages used as dependencies, and a Turborepo pipeline where ", _jsx(_components.code, {
        children: "test"
      }), " depends on ", _jsx(_components.code, {
        children: "^build"
      }), " topologically, running:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "./apps/web}[HEAD^1]^..."
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["would tell ", _jsx(_components.code, {
        children: "turbo"
      }), " to ensure dependencies are built and to run the ", _jsx(_components.code, {
        children: "test"
      }), " script in all of the local dependencies of the app located in ", _jsx(_components.code, {
        children: "./apps/web"
      }), ", not including that app itself, if the app has changed since HEAD^1."]
    }), "\n", _jsxs(_components.p, {
      children: ["For more details and examples, refer to the new ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#using-filters",
        children: "filtering documentation"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "debug-and-automate-with---dry-run",
      children: ["Debug and Automate with ", _jsx(_components.code, {
        children: "--dry-run"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["You can now see the impact of ", _jsx(_components.code, {
        children: "turbo run"
      }), " without actually executing any commands by appending either ", _jsx(_components.code, {
        children: "--dry-run"
      }), " or ", _jsx(_components.code, {
        children: "--dry-run=json"
      }), " to any ", _jsx(_components.code, {
        children: "turbo run"
      }), " command. This will result in either human or JSON output."]
    }), "\n", _jsx(_components.p, {
      children: "Dry runs are incredibly useful for two situations:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Debugging and testing run options"
      }), "\n", _jsxs(_components.li, {
        children: ["Using ", _jsx(_components.code, {
          children: "turbo"
        }), " filtering and task graphs for building automations"]
      }), "\n"]
    }), "\n", " ", "\n", _jsx("div", {
      className: "overflow-hidden lg:rounded-xl",
      children: _jsx(_components.p, {
        children: _jsx(_components.img, {
          alt: "Turborepo Dry Run",
          placeholder: "blur",
          src: __img0
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["We hope that this will improve visibility into what ", _jsx(_components.code, {
        children: "turbo"
      }), " is doing, speeding up debugging, and make it easier to leverage ", _jsx(_components.code, {
        children: "turbo"
      }), " in dynamic CI/CD systems."]
    }), "\n", _jsx(_components.h2, {
      id: "improved-internal-scheduler-and-graph",
      children: "Improved Internal Scheduler and Graph"
    }), "\n", _jsxs(_components.p, {
      children: ["When using ", _jsx(_components.code, {
        children: "turbo run"
      }), ", every ", _jsx(_components.code, {
        children: "package.json"
      }), " task is added to an internal graph to map dependencies based on the inferred relationships defined in your Turborepo ", _jsx(_components.code, {
        children: "pipeline"
      }), ". This task graph allows Turborepo to efficiently schedule incremental concurrent task running and cache task outputs for later use."]
    }), "\n", _jsxs(_components.p, {
      children: ["We have made major improvements to the internal task scheduler and resulting graph structure, resulting in better performance and a better developer experience. For example, in many cases, you will no longer need to use ", _jsx(_components.code, {
        children: "--include-dependencies"
      }), ". Instead, after specifying your task entry points, the new and improved graph will automatically handle this graph resolution on your behalf."]
    }), "\n", _jsx(_components.h2, {
      id: "cache-outputs-integrity-and-signature-verification",
      children: "Cache Outputs Integrity and Signature Verification"
    }), "\n", _jsx(_components.p, {
      children: "You can now configure Turborepo to sign remote cache outputs using HMAC-SHA256 with a secret key before uploading them to the Remote Cache. When Turborepo downloads signed cache artifacts, it will now verify the artifact's integrity and authenticity. Any artifact that fails to verify will be ignored, discarded, and treated as a cache miss by Turborepo."
    }), "\n", _jsxs(_components.p, {
      children: ["To enable this feature, set the ", _jsx(_components.code, {
        children: "remoteCache"
      }), " options in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), " config file to include ", _jsx(_components.code, {
        children: "signature: true"
      }), ". Then specify your secret key by declaring the ", _jsx(_components.code, {
        children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
      }), " environment variable."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"[https://turborepo.com/schema.json](https://turborepo.com/schema.json)\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"remoteCache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // Indicates if signature verification is enabled."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"signature\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "other-bug-fixes-and-improvements",
      children: "Other bug fixes and improvements"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--sso-team"
        }), " flag now enables teams with SAML tokens to log in through ", _jsx(_components.code, {
          children: "turbo login"
        }), " with correct team permissions"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--log-output"
        }), " flag allows you to control what logs are printed to the terminal, and when, allowing you to focus only on what's new"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "FORCE_COLOR"
        }), " environment variable is now supported"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "TURBO_FORCE=true"
        }), " environment variable will now force execution"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--remote-only"
        }), " and ", _jsx(_components.code, {
          children: "TURBO_REMOTE_ONLY=true"
        }), " will tell ", _jsx(_components.code, {
          children: "turbo"
        }), " to only use Remote Caching"]
      }), "\n", _jsxs(_components.li, {
        children: ["We now show ", _jsx(_components.code, {
          children: ">>> FULL TURBO"
        }), " when there's at least one task attempted"]
      }), "\n", _jsxs(_components.li, {
        children: ["Yarn v2+ with Plug'n'Play (PnP linker) is supported for the ", _jsx(_components.code, {
          children: "turbo run"
        }), " command, but ", _jsx(_components.code, {
          children: "turbo prune"
        }), " is still not fully supported"]
      }), "\n", _jsxs(_components.li, {
        children: ["Fixed regression with chrome tracing if ", _jsx(_components.code, {
          children: "--profile"
        }), " is specified"]
      }), "\n", _jsxs(_components.li, {
        children: ["You can now set concurrency by percentage of CPUs with ", _jsx(_components.code, {
          children: "--concurrency=50%"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "were-hiring",
      children: "We're hiring!"
    }), "\n", _jsxs(_components.p, {
      children: ["The Turborepo team at ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), " is hiring! We're up to five core team members already this year and are looking to hire even more. We're specifically looking for full-time ", _jsx(_components.a, {
        href: "https://vercel.com/careers",
        children: "Senior Build Systems Engineers"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "whats-next",
      children: "What's next?"
    }), "\n", _jsxs(_components.p, {
      children: ["Along with seamless incremental adoption/migration and speeding up CI/CD, we've been focusing on improving Turborepo's day-to-day ergonomics, security, and observability. The new ", _jsx(_components.code, {
        children: "--filter"
      }), " flag, signed artifacts, and dry runs are important steps toward those goals."]
    }), "\n", _jsx(_components.p, {
      children: "Next up, we'll be focusing an enhanced local development experience, codebase automations, and overall CLI performance."
    }), "\n", _jsx(_components.h2, {
      id: "thank-you-contributors",
      children: "Thank you, contributors"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of over 95 individual developers and our core team."
    }), "\n", _jsx(_components.p, {
      children: "This release was brought to you by the contributions of: @gsoltis09, @jaredpalmer, @gaspar09, @shuding, @rajatkulkarni95, @VanTanev, @Kikobeats, @tknickman, @thebanjomatic, @chelkyl, @elado, @finn-orsini, @becca, @weyert, @ekosz"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
